import { OrderFlow } from '../types/order/orderFlow';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const LIST = '/api/order/flow/list';

export namespace OrderFlowRequest {
  export const list = async (payload: { page: number }): Promise<PaginatedResponse<OrderFlow>> => {
    return (await http.post(LIST, payload)).data;
  };
}
